import mapActions from './mapActions';

export default mapActions('operation_work', {
    fetchAll_url: data => `/api/building_entities/${data.id}/work_history`
});
